/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardTileDto } from '../../models/dashboard-tile-dto';
import { UpdateDashboardTileRequest } from '../../models/update-dashboard-tile-request';

export interface DashboardsTilesDashboardTileIdPut$Plain$Params {
  dashboardTileId: string;
      body?: UpdateDashboardTileRequest
}

export function dashboardsTilesDashboardTileIdPut$Plain(http: HttpClient, rootUrl: string, params: DashboardsTilesDashboardTileIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardTileDto>> {
  const rb = new RequestBuilder(rootUrl, dashboardsTilesDashboardTileIdPut$Plain.PATH, 'put');
  if (params) {
    rb.path('dashboardTileId', params.dashboardTileId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DashboardTileDto>;
    })
  );
}

dashboardsTilesDashboardTileIdPut$Plain.PATH = '/dashboards/tiles/{dashboardTileId}';
